import { omniAtom } from "src/utils/atoms";

const prefix = "modals/StatusModal";

export interface StatusModalData {
  title: string;
  content: string;
  onContinue?: () => void;
}

export const statusModalDataAtom = omniAtom({
  prefix,
  key: "state",
  value: null as StatusModalData | null,
});
